module.exports = __webpack_public_path__ + "static/media/navbar_logo.3f2b90e2.svg";